<template>
	<div class="question-container">
		<div>
			<div
				class="question-text"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div
				class="loading"
				v-if="isBusy"
			>
				<LoaderComponent />
			</div>
			<div
				v-else
				class="input-text"
			>
				<div
					:style="{
						color: v$.textValue.$invalid ? theme.errorInputAccentColor : theme.mainTextColor,
					}"
				>
					<InputDropdown
						v-model:saturn="textValue"
						:list="dropdownDataList"
						:valueMap="p => p[dropdownValueKey]"
						:text="p => p[dropdownTextKey]"
						:invalid="v$.textValue.$invalid"
					/>
				</div>
			</div>
		</div>
		<div class="question-continue-button">
			<button
				class="button"
				:style="{
					background: theme[answer.style.background],
					color: theme[answer.style.text],
				}"
				@click="answer.actions(textValue, [], data.question, toggleLoading, saveApplicationAction)"
				:disabled="!data.question.isValidationsMet(answer, v$.textValue)"
			>
				{{ data.question.getLocalizationDisplay(answer.label, data.language) }}
			</button>
		</div>
	</div>
</template>

<script>
	import InputDropdown from '@/components/customerApp/InputDropdown.vue';
	import { required, minLength, between } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';
	import * as ApplicationsSettingsDropdowns from '@core/classes/Applications/ApplicationsSettingsDropdowns';
	import LoaderComponent from '@core/components/UI/LoaderComponent.vue';

	export default {
		name: 'QuestionInputDropdown',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				answer: {},
				textValue: null,
				dropdownTextKey: null,
				dropdownValueKey: null,
				dropdownDataList: [],
				isBusy: false,
			};
		},
		computed: {},
		async created() {
			this.answer = this.data.question.getAnswers()[0];
			console.log('Answers', this.answer);
			this.textValue = this.data.question.savedAnswer;
			await this.populateDropdownOptions();
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
					this.populateDropdownOptions();
				},
				{ deep: true },
			);
		},

		validations() {
			if (this.data.question.GetValidation) {
				return this.data.question.GetValidation();
			}
		},
		methods: {
			toggleLoadingQuestion() {
				this.isBusy = !this.isBusy;
			},
			async populateDropdownOptions() {
				if (this.data.question.dropdown) {
					this.dropdownDataList = [];
					const { listMethod, keys } = this.data.question.dropdown;
					this.dropdownTextKey = keys.text;
					this.dropdownValueKey = keys.value;
					this.dropdownDataList = await ApplicationsSettingsDropdowns[listMethod](keys, this.data.language, this.data.application, this.toggleLoadingQuestion);
					this.textValue = this.data.question.savedAnswer;
				}
			},
		},
		components: {
			InputDropdown,
			LoaderComponent,
		},
	};
</script>

<style></style>
